export const BREAKPOINTS = {
  phone: '320px',
  tabletMini: '600px',
  tablet: '960px',
  desktop: '1280px',
};

export const BREAKPOINTS_NUM = {
  phone: 320,
  tabletMini: 600,
  tablet: 960,
  desktop: 1280,
};
